import React from 'react';
import PropTypes from 'prop-types';

/**
 * Used for displaying links in questions and documents
 */
class LinkDisplay extends React.PureComponent {
    static propTypes = {
        model: PropTypes.object.isRequired,
        reportReady: PropTypes.func.isRequired,
    };

    componentDidMount() {
        this.props.reportReady(true);
    }

    render() {
        const { url, linkTarget, linkContent } = this.props.model;

        return (
            <a href={url} target={linkTarget}>{linkContent}</a>
        );
    }
}

export default LinkDisplay;
